// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1H-tj","unreadBadge":"styles_unreadBadge__2GEHl","modalContent":"styles_modalContent__dXv9s","modal":"styles_modal__2oFv0"};